/** @format */

import {ValueList} from 'features/forecast/types';

interface ChartDataWithPrimary {
  primary?: number;
}

/**
 * Собирает список значений по основному графику: {pointName: primary value}.
 * Нужно для расчёта прогноза на основе primary значений.
 * points должен полностью соответствовать полям name внутри CommonChartData и перечисляться в том же порядке.
 * @param chartsData
 * @param points
 */

const getPrimaryValuesList = <V extends ChartDataWithPrimary>(
  chartsData: V[],
  points: string[],
): ValueList => {
  return points.reduce<ValueList>((acc, pointName, index) => {
    acc[pointName] = chartsData[index]?.primary ?? 0;
    return acc;
  }, {});
};

export {getPrimaryValuesList};
